import { MoneyType as MoneyApiType } from 'src/api/generated/touring/types';
import { MoneyType } from '../../types';

export const mapMoneyType = (apiType: MoneyApiType): MoneyType => {
  return {
    value: apiType.value,
    currency: apiType.currency,
  };
};

